import React, { useCallback, useEffect, useState } from 'react';
import Heading from 'components/Heading/Heading';
import { P } from 'components/reusable-css';
import * as Styles from 'pages/member/firewall/FireWall.style';
import { useTranslation } from 'react-i18next';
import CardList from './firewall/CardList';
import CreateTemplate from './firewall/CreateTemplate';
import { useMutation } from 'react-query';
import { CREATE_FIREWALL } from './queries';
import { mutationProps } from 'utils/custom-hook';
import { Base64 } from 'js-base64';
import CreateTemplatePanel from './firewall/CreateTemplatePanel';
import SlidingPanels from 'components/common/sliding-panel';
import { useMediaQuery } from '@mui/material';

const FirewallTemplate = ({ vsFirewall, refetch }) => {
  const [show, setShow] = useState(false);
  const [rowID, setRowId] = useState();
  const { t } = useTranslation();
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isOpenCreateTemp, setIsOpenCreateTemp] = useState(false);
  const [isOpenCreateObj, setIsOpenCreateObj] = useState(false);
  const [label, setLabel] = useState('');
  const [createObj, setCreateObj] = useState('');
  const { mutate: createFirewall, isLoading: createFirewallLoading } = useMutation(CREATE_FIREWALL);
  const match = useMediaQuery('(max-width:550px)');

  const handleCreateRule = async (value, action) => {
    await createFirewall(
      {
        label: Base64.btoa(value),
        action,
      },
      mutationProps(
        false,
        {
          onSuccess: async (res) => {
            await refetch();
            setCreateObj(res);
            setIsOpenModal(false);
            setIsOpenCreateTemp(true);
          },
        },
        t,
      ),
    );
  };

  const handleNameSubmit = (value) => {
    const isValid = value.length != 0;
    if (isValid) {
      handleCreateRule(value, 'new');
    }
  };

  const handleToggle = (item) => {
    setShow(!show);
    setRowId(item);
  };

  const handleCreateTempModal = (value) => {
    setIsOpenCreateTemp(!isOpenCreateTemp);
    if (value) setLabel('');
  };

  const escFunction = useCallback(
    (event) => {
      if (event.key === 'Escape') {
        if (isOpenCreateObj) {
          setIsOpenCreateObj(false);
          return;
        }
        setIsOpenCreateTemp(false);
      }
    },
    [isOpenCreateObj, isOpenCreateTemp],
  );

  useEffect(() => {
    document.addEventListener('keydown', escFunction, false);

    return () => {
      document.removeEventListener('keydown', escFunction, false);
    };
  }, [escFunction]);

  return (
    <Styles.Step2SC>
      <Heading
        name={'vs/firewall.string9'}
        button
        buttonTxt={'vs/firewall.string40'}
        buttonCick={() => setIsOpenModal(true)}
      >
        <Styles.FireWallSC>
          <P>{t('vs/firewall.string10')}</P>
          <Styles.ListContainer>
            {vsFirewall?.firewall_ruleset?.map(
              (item, index) =>
                item?.type == 'nonglobal' && (
                  <CardList
                    show={show}
                    rowID={rowID}
                    item={item}
                    key={index}
                    handleToggle={(val) => handleToggle(val)}
                    refetch={refetch}
                  />
                ),
            )}
          </Styles.ListContainer>
        </Styles.FireWallSC>
        {isOpenModal && (
          <CreateTemplate
            handleNameSubmit={handleNameSubmit}
            openFilter={isOpenModal}
            handleClose={() => setIsOpenModal(false)}
            isLoading={createFirewallLoading}
            label={label}
            setLabel={setLabel}
          />
        )}
        {isOpenCreateTemp && (
          <SlidingPanels size={match ? 93 : 78} isOpen={isOpenCreateTemp} isClose={setIsOpenCreateTemp}>
            <CreateTemplatePanel
              item_id={createObj?.item_id}
              label={label}
              isClose={(value) => handleCreateTempModal(value)}
              mainRefectch={refetch}
              isOpenCreateObj={isOpenCreateObj}
              setIsOpenCreateObj={setIsOpenCreateObj}
            />
          </SlidingPanels>
        )}
      </Heading>
    </Styles.Step2SC>
  );
};

export default FirewallTemplate;
